// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSciencePlantPot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.112 5c.257 1.148.734 1.771 1.228 2.15.719.55 1.823.85 3.378.85h.706c-.186-.679-.467-1.251-.811-1.698C9.006 5.515 8.12 5 6.838 5zm1.726-2c2.804 0 4.659 1.789 5.398 4.33C13.355 5.9 14.98 5 16.787 5h2.524c.53 0 .965.45.92 1-.34 4.274-2.905 6-6.025 6h-1.608v1h6.24a.49.49 0 0 1 .48.5v1a.49.49 0 0 1-.48.5h-1.44v4c0 1.657-1.29 3-2.88 3h-5.76c-1.59 0-2.88-1.343-2.88-3v-4h-1.44a.49.49 0 0 1-.48-.5v-1c0-.276.215-.5.48-.5h6.24v-3h-.96c-3.476 0-6.336-1.304-6.684-6-.04-.551.394-1 .924-1zm10.168 6.089c.461-.414.89-1.062 1.135-2.089h-1.354c-1.616 0-3.174 1.166-3.845 3h1.264c1.232 0 2.164-.339 2.8-.911zM7.798 19c0 .552.43 1 .96 1h5.76c.53 0 .96-.448.96-1v-4h-7.68z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSciencePlantPot;
